import * as React from 'react'

import type { NextPage } from '@grandvisionhq/next'
import { compose } from '@grandvisionhq/utils'
import { DefaultForms, SlotsProvider } from '@grandvisionhq/www-next/pages/my-account'
import { Page } from '@grandvisionhq/www-next/pages/my-account/profile'

import withCms from '../../../cms/with-cms'
import withLayout from '../../../cms/with-layout'
import AddressForm from '../../../components/forms/Address'
import { withCart } from '../../../components/hocs/with-cart'

import '@grandvisionhq/my-account/dist/index.css'

const MyAccountProfile: NextPage = () => {
  const slots = {
    personalDetailsFormSlot: DefaultForms.PersonalDetailsForm,
    personalDetailsSummarySlot: DefaultForms.PersonalDetailsSummary,
    addressFormSlot: AddressForm,
    addressSummarySlot: DefaultForms.AddressSummary,
    preferredStoreSummarySlot: DefaultForms.PreferredStoreSummary,
  }
  return (
    <SlotsProvider slots={slots}>
      <Page />
    </SlotsProvider>
  )
}

export default compose(withCms(), withLayout(), withCart({ isReadOnly: true }))(MyAccountProfile)
